export default "__VITE_ASSET__CqCP2adL__"